import React, { Component } from "react"
import Modal from "react-modal"
import LoginForm from "./LoginForm"
import SignUpForm from "./SignUpForm"
import ForgotPasswordForm from "./ForgotPasswordForm"
import ResetPasswordForm from "./ResetPasswordForm"
import { AUTH_TYPES } from "constants/auth-types"
// Import Styles
import "styles/components/auth/auth.scss"

export class AuthModal extends Component {
  renderForm(isAuthType) {
    switch (isAuthType) {
      case AUTH_TYPES.LOGIN:
        return <LoginForm />
      case AUTH_TYPES.REGISTER:
        return <SignUpForm />
      case AUTH_TYPES.FORGOT_PASSWORD:
        return <ForgotPasswordForm />
      case AUTH_TYPES.RESET_PASSWORD:
        return <ResetPasswordForm />
      default:
    }
  }

  render() {
    const { authType, isOpen, closeModal } = this.props
    const schoolLogo = localStorage.getItem("schoolLogo")
    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel={authType}
        ariaHideApp={false}
        className="auth-modal-modal"
        overlayClassName="auth-modal-overlay"
      >
        <div className="login-wrapper">
          <div className="left-panel">
            <div className="bg-container">
              <img src={schoolLogo} alt="logo" className="logo" />
            </div>
          </div>
          <div className="right-panel">
            <span onClick={closeModal}>x</span>
            {this.renderForm(authType)}
          </div>
        </div>
      </Modal>
    )
  }
}

export default AuthModal
